module.exports = "/_next/static/images/coby-brandt@3x-9cb6b470e4089d76037a45b8a194b47d.png";